import { useRecordContext } from "react-admin";
import { Button } from "react-admin";
import CancelIcon from "@mui/icons-material/Cancel";
import { Student } from "../providers/studentsProvider";

export const CancelDunningProcessButton = ({ onClick }: { onClick: (student: Student) => void }) => {
  const student = useRecordContext<Student>();
  if (!student.dunningProcess) {
    return null;
  }
  return (
    <Button sx={{ px: 2 }} onClick={() => onClick(student)} startIcon={<CancelIcon />} label="Prozess abbrechen" />
  );
};
